module.exports = __webpack_public_path__ + "media/application/images/projects/images/usa-84636bbea62c725090ab0046f5e07d8a.jpg";